import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { Observable } from 'rxjs';
import { environment } from '../../environments/environment';
import { Titulo, EditalTitulo, CreateTituloRequest, CreateEditalTituloRequest } from '../models/titulo.model';

@Injectable({
  providedIn: 'root'
})
export class TituloService {
  private apiUrl = `${environment.apiUrl}/admin/titulos`;

  constructor(private http: HttpClient) {}

  // Títulos
  getAll(): Observable<Titulo[]> {
    return this.http.get<Titulo[]>(this.apiUrl);
  }

  getAtivos(): Observable<Titulo[]> {
    return this.http.get<Titulo[]>(`${this.apiUrl}/ativos`);
  }

  getById(id: number): Observable<Titulo> {
    return this.http.get<Titulo>(`${this.apiUrl}/${id}`);
  }

  create(titulo: CreateTituloRequest): Observable<Titulo> {
    return this.http.post<Titulo>(this.apiUrl, titulo);
  }

  update(id: number, titulo: CreateTituloRequest): Observable<Titulo> {
    return this.http.put<Titulo>(`${this.apiUrl}/${id}`, titulo);
  }

  delete(id: number): Observable<void> {
    return this.http.delete<void>(`${this.apiUrl}/${id}`);
  }

  // Títulos do Edital
  getEditalTitulos(editalId: number): Observable<EditalTitulo[]> {
    return this.http.get<EditalTitulo[]>(`${environment.apiUrl}/admin/editais/${editalId}/titulos`);
  }

  getEditalTitulosAtivos(editalId: number): Observable<EditalTitulo[]> {
    return this.http.get<EditalTitulo[]>(`${environment.apiUrl}/admin/editais/${editalId}/titulos/ativos`);
  }

  // Endpoint público para candidatos (se disponível)
  getEditalTitulosAtivosPublic(editalId: number): Observable<EditalTitulo[]> {
    return this.http.get<EditalTitulo[]>(`${environment.apiUrl}/editais/${editalId}/titulos/ativos`);
  }

  getEditalTituloById(editalId: number, id: number): Observable<EditalTitulo> {
    return this.http.get<EditalTitulo>(`${environment.apiUrl}/admin/editais/${editalId}/titulos/${id}`);
  }

  createEditalTitulo(editalId: number, editalTitulo: CreateEditalTituloRequest): Observable<EditalTitulo> {
    return this.http.post<EditalTitulo>(`${environment.apiUrl}/admin/editais/${editalId}/titulos`, editalTitulo);
  }

  updateEditalTitulo(editalId: number, id: number, editalTitulo: CreateEditalTituloRequest): Observable<EditalTitulo> {
    return this.http.put<EditalTitulo>(`${environment.apiUrl}/admin/editais/${editalId}/titulos/${id}`, editalTitulo);
  }

  deleteEditalTitulo(editalId: number, id: number): Observable<void> {
    return this.http.delete<void>(`${environment.apiUrl}/admin/editais/${editalId}/titulos/${id}`);
  }
}
